var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../../buttons/tool-icon-button.js';
import './note-menu.js';
import { WithDisposable } from '@blocksuite/lit';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { DEFAULT_NOTE_COLOR } from '../../../../../_common/edgeless/note/consts.js';
import { ArrowUpIcon, NoteIcon } from '../../../../../_common/icons/index.js';
import { getTooltipWithShortcut } from '../../../components/utils.js';
import { createPopper } from '../common/create-popper.js';
let EdgelessNoteToolButton = class EdgelessNoteToolButton extends WithDisposable(LitElement) {
    constructor() {
        super(...arguments);
        this._noteMenu = null;
    }
    _toggleNoteMenu() {
        if (this._noteMenu) {
            this._noteMenu.dispose();
            this._noteMenu = null;
        }
        else {
            this._noteMenu = createPopper('edgeless-note-menu', this, {
                x: 110,
                y: -40,
            });
            this._noteMenu.element.edgelessTool = this.edgelessTool;
            this._noteMenu.element.edgeless = this.edgeless;
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('edgelessTool')) {
            if (this.edgelessTool.type !== 'note') {
                this._noteMenu?.dispose();
                this._noteMenu = null;
            }
            if (this._noteMenu) {
                this._noteMenu.element.edgelessTool = this.edgelessTool;
                this._noteMenu.element.edgeless = this.edgeless;
            }
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this._disposables.add(this.edgeless.slots.edgelessToolUpdated.on(newTool => {
            if (newTool.type !== 'note') {
                this._noteMenu?.dispose();
                this._noteMenu = null;
            }
        }));
    }
    disconnectedCallback() {
        this._noteMenu?.dispose();
        this._noteMenu = null;
        super.disconnectedCallback();
    }
    render() {
        const type = this.edgelessTool?.type;
        const arrowColor = type === 'note' ? 'currentColor' : '#77757D';
        return html `
      <edgeless-tool-icon-button
        class="edgeless-note-button"
        .tooltip=${this._noteMenu ? '' : getTooltipWithShortcut('Note', 'N')}
        .tooltipOffset=${17}
        .active=${type === 'note'}
        .iconContainerPadding=${8}
        @click=${() => {
            this.setEdgelessTool({
                type: 'note',
                background: DEFAULT_NOTE_COLOR,
                childFlavour: 'affine:paragraph',
                childType: 'text',
                tip: 'Text',
            });
            this._toggleNoteMenu();
        }}
      >
        ${NoteIcon}
        <span class="arrow-up-icon" style=${styleMap({ color: arrowColor })}>
          ${ArrowUpIcon}
        </span>
      </edgeless-tool-icon-button>
    `;
    }
};
EdgelessNoteToolButton.styles = css `
    :host {
      display: flex;
    }

    .arrow-up-icon {
      position: absolute;
      top: 4px;
      right: 2px;
      font-size: 0;
    }
  `;
__decorate([
    property({ attribute: false })
], EdgelessNoteToolButton.prototype, "edgelessTool", void 0);
__decorate([
    property({ attribute: false })
], EdgelessNoteToolButton.prototype, "edgeless", void 0);
__decorate([
    property({ attribute: false })
], EdgelessNoteToolButton.prototype, "setEdgelessTool", void 0);
EdgelessNoteToolButton = __decorate([
    customElement('edgeless-note-tool-button')
], EdgelessNoteToolButton);
export { EdgelessNoteToolButton };
//# sourceMappingURL=note-tool-button.js.map